import { Box, Typography } from "@mui/material";
import PlaceIcon from "@mui/icons-material/Place";
import { colors } from "../../../../ui/colors";

interface Props {
  coverage: any;
}

export const JobCardLocation = ({ coverage }: Props) => {
  if (!coverage) return null;

  return (
    <Box display="flex" alignItems="center" gap={1.5} mt={2}>
      <PlaceIcon sx={{ color: colors.orange.base, fontSize: 20 }} />
      <Box>
        <Typography
          variant="caption"
          sx={{
            color: colors.gray[400],
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: "0.04em",
            fontSize: "0.6rem",
            display: "block",
          }}
        >
          Location
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 500, color: colors.gray[700], fontSize: "0.74rem", lineHeight: 1.35 }}>
          {coverage.address || `${coverage.city ?? ""}${coverage.state ? ", " + coverage.state : ""}`}
        </Typography>
      </Box>
    </Box>
  );
};
